import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-170c28fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "our-choice-section" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mediabuying-section-title" }, " THE BEST CHOICE ", -1))
const _hoisted_4 = { class: "mediabuying-section-subtitle" }
const _hoisted_5 = { class: "text__accent" }
const _hoisted_6 = { class: "text__accent" }
const _hoisted_7 = { class: "text__accent" }
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<ul class=\"choice__list\" data-v-170c28fc><li class=\"choice__item\" data-v-170c28fc></li><li class=\"choice__item\" data-v-170c28fc></li><li class=\"choice__item\" data-v-170c28fc></li><li class=\"choice__item\" data-v-170c28fc></li><li class=\"choice__item\" data-v-170c28fc></li></ul>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _hoisted_3,
        _createElementVNode("h3", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('choice.we')), 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('choice.all')), 1),
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('choice.ar')), 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('choice.and')), 1),
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('choice.accept')), 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('choice.participate')), 1)
        ])
      ]),
      _hoisted_8
    ])
  ]))
}